import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import Error404 from "modules/core/pages/Error404";

import { researchPrivateRoutesConstants as routesConstants } from "./routesConstants";

import { componentLazyImport } from "modules/core/utils/helpers";

// Pages
const Research = lazy(() =>
  componentLazyImport(() => import("modules/research/pages/Research"))
);
const SingleResearch = lazy(() =>
  componentLazyImport(() => import("modules/research/pages/SingleResearch"))
);
const ObservationsPage = lazy(() =>
  componentLazyImport(() => import("modules/research/pages/Observations"))
);

const ResearchPrivateRoutes: React.FC = () => {
  return (
    <Switch>
      <Route path={routesConstants.root.path} exact>
        <Research />
      </Route>

      <Route path={routesConstants.observations.path}>
        <ObservationsPage />
      </Route>

      <Route path={routesConstants.single_research.path} exact>
        <SingleResearch />
      </Route>

      <Route>
        <Error404 />
      </Route>
    </Switch>
  );
};

export default ResearchPrivateRoutes;
